<footer class="footer" id="app-footer">
  <span class="copyright">
    <span title="{{buildDate}}">&copy;</span> Euro Pool System {{year}}
  </span>
  <span class="version" (click)="easterEggEnabled && versionClicked()">{{ version }}</span>
  <span *ngIf="easterEggEnabled && autologoutDisabled"> No auto-logout</span>

  <div class="links">
    <a href="{{ 'DASHBOARD.GENERAL.TERMS_OF_USE_LINK' | translate }}" target="_blank">
      {{ 'DASHBOARD.GENERAL.TERMS_OF_USE' | translate }}
    </a>
    <a href="{{ 'DASHBOARD.GENERAL.PRIVACY_LINK' | translate }}" target="_blank">
      {{ 'DASHBOARD.GENERAL.PRIVACY' | translate }}
    </a>
  </div>
</footer>
